import { render } from "./ConfirmationToken.vue?vue&type=template&id=02558273"
import script from "./ConfirmationToken.vue?vue&type=script&lang=js"
export * from "./ConfirmationToken.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__